import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pop_up applicant_chk com_pop" }
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sch_condition_wrap" }
const _hoisted_4 = { class: "left _column _flex" }
const _hoisted_5 = { class: "date_wrap" }
const _hoisted_6 = { class: "end_point" }
const _hoisted_7 = { class: "end_point" }
const _hoisted_8 = { class: "custom_scroll" }
const _hoisted_9 = { class: "areaAnswer" }
const _hoisted_10 = { class: "checkbox_wrap" }
const _hoisted_11 = { for: "generation1" }
const _hoisted_12 = ["checked"]
const _hoisted_13 = { for: "generation2" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = { for: "generation3" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = { for: "generation4" }
const _hoisted_18 = ["checked"]
const _hoisted_19 = { for: "generation5" }
const _hoisted_20 = ["checked"]
const _hoisted_21 = { for: "generation6" }
const _hoisted_22 = ["checked"]
const _hoisted_23 = { for: "generation7" }
const _hoisted_24 = ["checked"]
const _hoisted_25 = { class: "checkbox_wrap" }
const _hoisted_26 = { for: "chk1" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString($setup.state.boardItem.title), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "신청자", -1)),
              _createElementVNode("span", null, _toDisplayString($setup.props.answerInfo.name), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: "img/time_icon.png",
                  alt: ""
                }),
                _createTextVNode(" 신청일자 ")
              ], -1)),
              _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.dateFormatYY(new Date($setup.props.answerInfo.createDate), ".")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", null, [
            _cache[13] || (_cache[13] = _createElementVNode("p", null, "휴대폰", -1)),
            _createElementVNode("div", null, _toDisplayString($setup.props.answerInfo.phoneNum), 1)
          ]),
          _createElementVNode("li", null, [
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "이메일", -1)),
            _createElementVNode("div", null, _toDisplayString($setup.props.answerInfo.email), 1)
          ]),
          _createElementVNode("li", _hoisted_10, [
            _cache[29] || (_cache[29] = _createElementVNode("p", null, "나이", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "generation1",
                  name: "generation",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.props.answerInfo.age) = $event)),
                  value: 1,
                  checked: $setup.props.answerInfo.age === 1,
                  disabled: ""
                }, null, 8, _hoisted_12), [
                  [_vModelRadio, $setup.props.answerInfo.age]
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("em", null, null, -1)),
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "form_li_tit" }, "10대", -1))
              ]),
              _createElementVNode("label", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "generation2",
                  name: "generation",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.props.answerInfo.age) = $event)),
                  value: 2,
                  checked: $setup.props.answerInfo.age === 2,
                  disabled: ""
                }, null, 8, _hoisted_14), [
                  [_vModelRadio, $setup.props.answerInfo.age]
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("em", null, null, -1)),
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "form_li_tit" }, "20대", -1))
              ]),
              _createElementVNode("label", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "generation3",
                  name: "generation",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.props.answerInfo.age) = $event)),
                  value: 3,
                  checked: $setup.props.answerInfo.age === 3,
                  disabled: ""
                }, null, 8, _hoisted_16), [
                  [_vModelRadio, $setup.props.answerInfo.age]
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("em", null, null, -1)),
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "form_li_tit" }, "30대", -1))
              ]),
              _createElementVNode("label", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "generation4",
                  name: "generation",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.props.answerInfo.age) = $event)),
                  value: 4,
                  checked: $setup.props.answerInfo.age === 4,
                  disabled: ""
                }, null, 8, _hoisted_18), [
                  [_vModelRadio, $setup.props.answerInfo.age]
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("em", null, null, -1)),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "form_li_tit" }, "40대", -1))
              ]),
              _createElementVNode("label", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "generation5",
                  name: "generation",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.props.answerInfo.age) = $event)),
                  value: 5,
                  checked: $setup.props.answerInfo.age === 5,
                  disabled: ""
                }, null, 8, _hoisted_20), [
                  [_vModelRadio, $setup.props.answerInfo.age]
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("em", null, null, -1)),
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "form_li_tit" }, "50대", -1))
              ]),
              _createElementVNode("label", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "generation6",
                  name: "generation",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.props.answerInfo.age) = $event)),
                  value: 6,
                  checked: $setup.props.answerInfo.age === 6,
                  disabled: ""
                }, null, 8, _hoisted_22), [
                  [_vModelRadio, $setup.props.answerInfo.age]
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("em", null, null, -1)),
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "form_li_tit" }, "60대", -1))
              ]),
              _createElementVNode("label", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "generation7",
                  name: "generation",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.props.answerInfo.age) = $event)),
                  value: 7,
                  checked: $setup.props.answerInfo.age === 7,
                  disabled: ""
                }, null, 8, _hoisted_24), [
                  [_vModelRadio, $setup.props.answerInfo.age]
                ]),
                _cache[27] || (_cache[27] = _createElementVNode("em", null, null, -1)),
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "form_li_tit" }, "70대 이상", -1))
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_25, [
            _cache[32] || (_cache[32] = _createElementVNode("p", null, "개인정보 동의", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_26, [
                _createElementVNode("input", {
                  id: "chk1",
                  type: "checkbox",
                  disabled: "",
                  checked: $setup.props.answerInfo.isAgree == 1,
                  ref: "isAgree"
                }, null, 8, _hoisted_27),
                _cache[30] || (_cache[30] = _createElementVNode("em", null, null, -1)),
                _cache[31] || (_cache[31] = _createElementVNode("span", null, "개인정보 동의", -1))
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _cache[33] || (_cache[33] = _createElementVNode("p", null, "캠페인 참여 후기/더 알고 싶은 성매매 산업 내용", -1)),
            _createElementVNode("div", null, _toDisplayString($setup.props.answerInfo.reviewComment), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("button", {
          class: "submit_btn _130 _main_blue",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, "닫기")
      ])
    ])
  ], 64))
}